import { render, staticRenderFns } from "./CostRatesList.vue?vue&type=template&id=6df9fb84&scoped=true&"
import script from "./CostRatesList.vue?vue&type=script&lang=js&"
export * from "./CostRatesList.vue?vue&type=script&lang=js&"
import style0 from "./CostRatesList.vue?vue&type=style&index=0&id=6df9fb84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df9fb84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df9fb84')) {
      api.createRecord('6df9fb84', component.options)
    } else {
      api.reload('6df9fb84', component.options)
    }
    module.hot.accept("./CostRatesList.vue?vue&type=template&id=6df9fb84&scoped=true&", function () {
      api.rerender('6df9fb84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CostRatesList.vue"
export default component.exports